module.exports = __webpack_public_path__ + "img/tomorrow.ee4e06ba.png";